import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Modal } from '@binance-chain/honeycomb'

import isBrowserExtensionInstalled from '../../utils/isBrowserExtensionInstalled'
import { requestSelectedAddress, switchNetwork } from '../../utils/extensions'
import { saveAddress } from '../../utils/storage'
import { setFingerPrint } from '../../utils/fingerPrint'
import { getTokenType } from '../../utils/tokenTypes'
import { useI18n } from '../../i18n/util'
import { getAccount, setAccount } from '../../redux/account/action'
import { getOpenOrdersQS, getOrderHistoryQS } from '../../redux/order/action'
import { getTradeHistoryByAddressQS } from '../../redux/trade/action'
import CheckInstallModal from '../checkWallet'
import {
  Connection,
  Option,
  OptionContent,
  LeftContent,
  TypeName,
  ImgWrap,
  BinanceChain,
  LeftSide,
  Wallet,
  Original,
} from '../../components/walletmodal'

function UnlockWallet({ open, onClose, onClickUnlock }) {
  const [showBrowserExtensionModal, setShowBrowserExtensionModal] = useState(false)
  const dispatch = useDispatch()
  const { deviceInfo } = useSelector(state => state.globalData)
  const { locale, formatI18nText } = useI18n()

  const onClick = async () => {
    if (!isBrowserExtensionInstalled()) {
      setShowBrowserExtensionModal(true)
    } else {
      const address = await requestSelectedAddress()
      if (address.startsWith('0x')) {
        await switchNetwork()
        return
      }

      if (address && address !== '') {
        const flags = { isExtensionWallet: true }
        saveAddress(address, { keystore: 'HARDWARE', flags })
        setFingerPrint(deviceInfo, 'unlock_extension_wallet', address, '')
        dispatch(getAccount(address))
        dispatch(
          setAccount({
            address,
            flags,
            privateKey: 'HARDWARE',
          })
        )
        const tokenType = getTokenType()
        const params = {
          address,
          offset: 0,
          total: 1,
          limit: 30,
        }
        dispatch(getOpenOrdersQS({ params, tokenType }))
        dispatch(getOrderHistoryQS({ params, withLoading: true, tokenType }))
        dispatch(getTradeHistoryByAddressQS({ params, withLoading: true, tokenType }))
        onClose()
      }
    }
  }

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Modal.Header title={formatI18nText('unlockWallet.modal.title')} />
        <Modal.Content>
          <Connection>
            <Option onClick={onClick}>
              <OptionContent>
                <LeftSide>
                  <TypeName>{formatI18nText('unlockWallet.option.extension.title')}</TypeName>
                </LeftSide>
                <LeftContent>{formatI18nText('unlockWallet.option.extension.content')}</LeftContent>
              </OptionContent>
              <ImgWrap>
                <BinanceChain />
              </ImgWrap>
            </Option>

            <Option onClick={onClickUnlock}>
              <LeftSide>
                <TypeName>{formatI18nText('unlockWallet.option.wallet.connect')}</TypeName>
              </LeftSide>
              <ImgWrap>
                <Wallet />
              </ImgWrap>
            </Option>
          </Connection>
          <Original>
            <Link to={`/${locale}/unlock`}>
              {formatI18nText('unlockWallet.option.extension.link')}
            </Link>
          </Original>
        </Modal.Content>
      </Modal>
      <CheckInstallModal
        open={showBrowserExtensionModal}
        close={() => setShowBrowserExtensionModal(false)}
      />
    </>
  )
}

UnlockWallet.propTypes = {
  open: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickUnlock: PropTypes.func.isRequired,
}

export default UnlockWallet
